import React from 'react';
import styled from 'styled-components';
import radioBox from 'Assets/radio-button-inactive.svg';
import activeRadioBox from 'Assets/radio-button-active.svg';

interface RadioBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    usingRef: Function;
    showError: boolean;
}

const Input = styled.input`
    opacity: 0;
    position: absolute;
    z-index: -1;
`;

const Label = styled.label`
    &&& {
        white-space: normal;
        float: none;
        clear: none;
        cursor: pointer;
        margin-left: 0;
        position: relative;
        min-height: 22px;
        padding-top: 0;
        background-image: url(${radioBox});
        background-position: 0 -3px;
        background-repeat: no-repeat;
        padding-left: 30px;

        ${Input}:checked + & {
            background-image: url(${activeRadioBox});
        }

        &:after {
            content: none;
        }
    }
`;

const Radiobox: React.FunctionComponent<RadioBoxProps> = ({ usingRef, children, ...props }) => (
    <>
        <Input type="radio" ref={usingRef()} {...props} />
        <Label htmlFor={props.id}>{children}</Label>
    </>
);

export default Radiobox;
